<template>
  <div>
    <div v-tooltip.bottom="'Test VPN'" @click="callTestVpn()">
      <div class="cursor-pointer flex text-nash-neutral000">
        <TIcon icon="link" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { storeToRefs } from 'pinia'
import { defineComponent } from 'vue'
import { useNotificationStore } from '@/legacy/store/modules/notification'
import { NotificationType } from '@/legacy/types/notifications'
import { testVpn } from '@/libs/api/api'

export default defineComponent({
  components: {
    TIcon,
  },
  setup() {
    const { notification } = storeToRefs(useNotificationStore())
    const callTestVpn = async () => {
      const canHitVpn = await testVpn()
      if (canHitVpn) {
        useNotificationStore().setNotification({
          message: 'VPN test succeeded!',
          type: NotificationType.SUCCESS,
        })
      } else {
        useNotificationStore().setNotification({
          message: 'VPN failed to connect.',
          type: NotificationType.DANGER,
        })
      }
    }

    return {
      notification,
      callTestVpn,
    }
  },
})
</script>
